import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Input from "../../../../../../../components/textbox/Input";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import styles from "../../../../InfoCliniche/InfoCliniche.module.css";
import Utils from "../../../../../../../utils/Utils";

class LuogoDiEsposizione extends Component {
    // CORREZIONE: La chiave dello stato deve corrispondere esattamente a quella usata nel render
    state = {
        LuogoDiEsposizione: {
            nazioneEsposizione: "",
            indirizzoEsposizione: "",
            comuneEsposizione: "",
            tipoLuogoEsposizione: "",
            corretto: []
        },
        comuni: JSON.parse(sessionStorage.getItem("comuniPerCodice")),
        nazioni: JSON.parse(sessionStorage.getItem("nazioni")),
        nazioniPerCodice: JSON.parse(sessionStorage.getItem("nazioniPerCodice")),

    };

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
    }

    componentDidMount() {
        if (this.props.segnalazioneCopia?.schedaSpeciale?.luogoDiEsposizione) {
            let luogoDiEsposizione=this.props.segnalazioneCopia.schedaSpeciale.luogoDiEsposizione;
            if(luogoDiEsposizione.comuneEsposizione){
                let comune=this.state.comuni[luogoDiEsposizione.comuneEsposizione]
                luogoDiEsposizione.comuneEsposizione=comune
            }
            this.setState({
                LuogoDiEsposizione: 
                    luogoDiEsposizione
                
            }, () => this.aggiornaPadre());
        } else if (this.props.segnalazioneCopia.datiSpecifici?.viaggiESoggiorni?.estero) {
            this.setState({
                    LuogoDiEsposizione: {
                        nazioneEsposizione: this.props.segnalazioneCopia.datiSpecifici.viaggiESoggiorni.estero[0].paeseEsteroVisitato
                    }

                },
                () => {
                    console.log("STATE aggiornato:", this.state.LuogoDiEsposizione);
                    this.aggiornaPadre();
                }
            )

        } else {
            this.aggiornaPadre();
        }
    }

    riceviValore(field, event) {
        let valore = (event && event.target) ? event.target.value : event;

        // Approccio Immutabile per forzare il refresh dei RadioButton
        this.setState(prevState => {
            const nuovoStatoDati = {
                ...prevState.LuogoDiEsposizione,
                [field]: valore
            };
            return { LuogoDiEsposizione: nuovoStatoDati };
        }, () => {
            this.aggiornaPadre();
        });
    }

    aggiornaPadre() {
        this.controlloCorrettezza();
        if (this.props.controlloCorrettezza) this.props.controlloCorrettezza();
        
        let copiaDati = JSON.parse(JSON.stringify(this.state.LuogoDiEsposizione));
        
        // Gestione valore Autocomplete per il Backend
        if (copiaDati.comuneEsposizione && copiaDati.comuneEsposizione.codice) {
            copiaDati.comuneEsposizione = copiaDati.comuneEsposizione.codice;
        }

        let oggettoBE = Utils.removeEmptyValueFromObject(copiaDati);
        if (this.props.setLuogoDiEsposizione) {
            this.props.setLuogoDiEsposizione(this.state.LuogoDiEsposizione, Utils.removeFieldFromObject(oggettoBE, "corretto"));
        }
    }

    controlloCorrettezza() {
        let dati = this.state.LuogoDiEsposizione;
        dati.corretto = [];
    }

    render() {
        const { t } = this.props;
        
        // SAFE ACCESS: Usiamo un fallback nel caso lo stato sia sporco o non ancora inizializzato
        const data = this.state.LuogoDiEsposizione || {};
        const path = "SchedaSpecialeArbovirosi.LuogoDiEsposizione";

        return (
            <div className={"container"}>
                <div className={"row"} style={{ marginTop: "20px" }}>
                    <div className={"col-lg-6"}>
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t(`${path}.nazione`)}
                        </p>
                        <Autocomplete
                            id={"nazioneEsposizione"}
                            value={data.nazioneEsposizione}
                            keyField={"codice"}
                            descriptionField={"descrizione"}
                            suggestionField={"descrizione"}
                            onChange={this.riceviValore}
                            field={"nazioneEsposizione"}
                            placeholder={t(`${path}.placeholderNazione`)}
                            suggestions={this.state.nazioni}
                        >
                        </Autocomplete>
                    </div>
                </div>

                <div className={"row"} style={{ marginTop: "15px" }}>
                    <div className={"col-lg-3"}>
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t(`${path}.indirizzo`)}
                        </p>
                        <Input
                            id="indirizzoEsposizione"
                            field="indirizzoEsposizione"
                            value={data.indirizzoEsposizione || ""}
                            onChange={this.riceviValore}
                            placeholder={t(`${path}.placeholderIndirizzo`)}
                        />
                    </div>

                    <div className={"col-lg-3"}>
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t(`${path}.comune`)}
                        </p>
                        <Autocomplete
                            id="comuneEsposizione"
                            field="comuneEsposizione"
                            value={data.comuneEsposizione || ""}
                            suggestions={this.state.comuni}
                            keyField="codice"
                            descriptionField="descrizione"
                            suggestionField="descrizione"
                            onChange={this.riceviValore}
                            placeholder={t(`${path}.comune`)}
                        />
                    </div>
                </div>

                <div className={"row"} style={{ marginTop: "20px", marginBottom: "30px" }}>
                    <div className={"col-lg-3"}>
                        <p className={styles.labelHeader} style={{ color: "#1b7ea9" }}>
                            {t(`${path}.tipoLuogo`)}
                        </p>
                    </div>

                    <div className={"col-lg-2"}>
                        <RadioButton
                            id="domicilioAbituale"
                            name="tipoLuogoEsposizione"
                            label={t(`${path}.opzioniTipo.domicilio`)}
                            value="01"
                            field="tipoLuogoEsposizione"
                            checked={data.tipoLuogoEsposizione === "01"}
                            onClick={this.riceviValore}
                            newRadio={true}
                        />
                    </div>

                    <div className={"col-lg-2"}>
                        <RadioButton
                            id="altroDomicilio"
                            name="tipoLuogoEsposizione"
                            label={t(`${path}.opzioniTipo.altro`)}
                            value="02"
                            field="tipoLuogoEsposizione"
                            checked={data.tipoLuogoEsposizione === "02"}
                            onClick={this.riceviValore}
                            newRadio={true}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(LuogoDiEsposizione);